<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
    />
    <div class="form-heading" :style="formHeadingStyle">
      <div class="form-title">
        <h1
          class="formester__heading"
          :style="headingStyle"
          v-html="label"
        ></h1>
        <h3 class="formester__subheading" :style="descriptionStyles">
          <template v-if="item.sublabel">
            {{ item.sublabel }}
          </template>
          <span v-else-if="editing && active" class="placeholder-description">
            Some Sub-text (Optional)
          </span>
        </h3>
      </div>
      <img
        v-if="
          styling.logoImage && styling.logoImage.image && styling.inFormLogo
        "
        :src="styling.logoImage.image"
        class="form-heading-logo"
        alt="Brand Logo"
        :style="logoStyling"
      />
    </div>
  </div>
</template>

<script>
import ElementControls from "./element-controls.vue";
import commonStyles from "./mixins/commonStyles";
import sharedActions from "./mixins/sharedActions";

export default {
  name: "Heading",
  components: {
    ElementControls,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "duplicate", "page-break"],
  computed: {
    headingStyle() {
      return {
        // default styles
        "overflow-wrap": "break-word",
        // custom styles
        color: this.item.overrideColor
          ? this.itemStyling.color
          : this.styling.fontColor || "#000000",
        "font-size": `${this.itemStyling.labelFontSize}px` || "36px",
        "font-weight": this.itemStyling.labelBold ? "bold" : "normal",
        "font-style": this.itemStyling.labelItalic ? "italic" : "normal",
        "font-family": this.styling.fontFamily || "sans-serif",
        "line-height": "125%",
      };
    },
    logoStyling() {
      return {
        background: this.styling.logoBoxColor || "#00000000",
        padding: "5px",
        "border-radius": "5px",
        height: `${this.styling.logoSize || 60}px`,
      };
    },
    formHeadingStyle() {
      let alignment = this.itemStyling.alignment;
      return {
        "flex-direction":
          alignment === "center"
            ? "column"
            : alignment === "left"
            ? "row"
            : "row-reverse",
        "text-align": alignment || "left",
      };
    },
  },
};
</script>

<style scoped>
.form-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-heading-logo {
  margin: 5px;
}
</style>
